"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("./icon"));

var _modal = require("./modal");

require("../css/sidemodal.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var SideModal =
/*#__PURE__*/
function (_Modal) {
  _inherits(SideModal, _Modal);

  function SideModal() {
    _classCallCheck(this, SideModal);

    return _possibleConstructorReturn(this, _getPrototypeOf(SideModal).apply(this, arguments));
  }

  _createClass(SideModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      /* This inerith method is not needed by SideModal */
    }
  }, {
    key: "render",
    value: function render() {
      var _sideModalClasses,
          _this = this;

      var _this$props = this.props,
          children = _this$props.children,
          dismissOnOverlayClick = _this$props.dismissOnOverlayClick,
          i18n = _this$props.i18n,
          show = _this$props.show,
          side = _this$props.side,
          title = _this$props.title;
      var sideClass = side === 'right' ? 'vn-sidemodal--right' : 'vn-sidemodal--left';
      var sideModalClasses = (_sideModalClasses = {
        'vn-sidemodal': true
      }, _defineProperty(_sideModalClasses, sideClass, true), _defineProperty(_sideModalClasses, "".concat(sideClass, "--open"), show), _sideModalClasses);

      var sideModal = _react.default.createElement("div", {
        className: (0, _classnames.default)(sideModalClasses)
      }, _react.default.createElement("button", {
        className: "vn-sidemodal__close",
        onClick: this.closeModal,
        title: i18n.close,
        type: "button"
      }, _react.default.createElement(_icon.default, {
        name: "close"
      })), title ? _react.default.createElement("div", {
        className: "vn-sidemodal__header"
      }, _react.default.createElement("h4", null, title)) : '', _react.default.createElement("div", {
        className: "vn-sidemodal__content"
      }, _react.default.createElement("div", {
        className: "vn-sidemodal__body"
      }, children)));

      if (dismissOnOverlayClick) {
        var sideModalOverlayClasses = {
          'vn-sidemodal__overlay': true,
          'vn-sidemodal__overlay--open': show
        };
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(sideModalOverlayClasses),
          onClick: this.handleOverlayClick,
          onKeyDown: this.handleOverlayKeyDown,
          ref: function ref(node) {
            _this.overlayNode = node;
          },
          role: "none"
        }, sideModal);
      }

      return sideModal;
    }
  }]);

  return SideModal;
}(_modal.Modal);

SideModal.propTypes = {
  children: _propTypes.default.node,
  dismissOnOverlayClick: _propTypes.default.bool,
  i18n: _propTypes.default.shape({
    close: _propTypes.default.string.isRequired
  }),
  onClose: _propTypes.default.func,
  show: _propTypes.default.bool,
  side: _propTypes.default.oneOf(['left', 'right']),
  title: _propTypes.default.string
};
SideModal.defaultProps = {
  children: null,
  dismissOnOverlayClick: false,
  i18n: {
    close: 'Close'
  },
  onClose: function onClose() {},
  show: false,
  side: 'right',
  title: null
};
SideModal.displayName = 'SideModal';
var _default = SideModal;
exports.default = _default;